import { currencySchema, positiveCurrencySchema } from "@inrev/common";
import { z } from "zod";
import type { BondFormData } from "../../../types";

export const commercialBondFormSchema = z.object({
	bondAmount: currencySchema.nullish(),
	effectiveDate: z.string().nullish(),
	submissionNarrative: z.string().nullish(),
	bondForm: z.custom<BondFormData>().optional(),
});

export const commercialBondSubmitSchema = commercialBondFormSchema.extend({
	bondAmount: z.number({ error: "Required" }).pipe(positiveCurrencySchema),
	effectiveDate: z.string({ error: "Required" }).min(1, { error: "Required" }),
});
